module.exports = __webpack_public_path__ + "static/media/Ultra Light.27438e9d.jpg";